import React, { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { makeStyles } from "@material-ui/core/styles";

import "./Accont.css";
import { imageURL } from "../../../api/index";
import { updatePatientProfile, getPatientProfile } from "../../../api/index";

import { buildFormData } from "../../../buildFormData";

import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { loadUser } from "../../../actions/userActions";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function Account() {
  const currentDate = new Date().toISOString().split("T")[0];

  const classes = useStyles();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [image, setImage] = useState();
  const [imagePreview, setImagePreview] = useState();
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [passwordErrors, setPasswordErrors] = useState({});
  const [confirmPassword, setConfirmPassword] = useState("");
  const [address, setAddress] = useState({
    state: "",
    city: "",
    location: "",
    postalCode: "",
  });

  const dispatch = useDispatch();
  useQuery(["patientProfile"], getPatientProfile, {
    retry: 1,
    retryDelay: 500,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      console.log(data?.data);
      setFirstName(data?.data?.user?.firstName);
      setLastName(data?.data?.user?.lastName);
      setEmail(data?.data?.user?.email);
      setPhoneNumber(data?.data?.user?.phoneNumber);
      setGender(data?.data?.user?.patientProfile?.gender);
      setDateOfBirth(data?.data?.user?.patientProfile?.dateOfBirth);
      setImage(data?.data?.user?.profilePicture);
      setAddress(data?.data?.user?.patientProfile?.address);
    },
  });

  const onFileChange = (e) => {
    setImage(e.target.files[0]);
    e.target.files.length > 0 &&
      setImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const queryClient = useQueryClient();
  const { mutate } = useMutation(updatePatientProfile, {
    onSuccess: (data) => {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Success! Your profile has been updated",
        showConfirmButton: false,
        timer: 2000,
      });
      queryClient.invalidateQueries("patientProfile");
      dispatch(loadUser());
    },
    onError: (error) => {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Oops! Couldn't updated profile.",
        text: error?.response?.data?.message,
        showConfirmButton: false,
        timer: 2000,
      });
    },
  });

  const UpdatePassword = async (e) => {
    e.preventDefault();

    const validityPassword = validatePassword();
    if (validityPassword) return;
    var formdata = new FormData();
    // setLoading(true);
    const updateDataObj = {
      password,
      confirmPassword,
    };

    buildFormData(formdata, updateDataObj);
    if (password && confirmPassword) {
      try {
        Swal.showLoading();
        mutate(formdata);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log("password is required");
    }
  };

  const UpdateProfile = async (e) => {
    e.preventDefault();
    const validity = validate();
    if (validity) return;
    var formdata = new FormData();
    // setLoading(true);

    const updateDataObj = {
      firstName,
      lastName,
      email,
      phoneNumber,
      gender,
      dateOfBirth,
      address,
    };

    buildFormData(formdata, updateDataObj);
    formdata.append("image", image);

    try {
      Swal.showLoading();
      mutate(formdata);
    } catch (e) {
      console.log(e);
    }
  };

  // validates the Personal Info
  const validate = () => {
    let errors = {};

    if (!firstName) errors.firstName = "First Name is required";
    if (!lastName) errors.lastName = "Last Name is required";
    if (!email) errors.email = "Email is required";
    if (!phoneNumber) errors.phoneNumber = "Phone number is required";

    setErrors(errors);
    const validity = Object.keys(errors).length > 0;
    return validity;
  };
  // Validate Password
  const validatePassword = () => {
    let passwordErrors = {};
    if (!password) passwordErrors.password = "password is required";
    if (!confirmPassword)
      passwordErrors.confirmPassword = "Confirm Password is required";

    setPasswordErrors(passwordErrors);
    const validityPassword = Object.keys(errors).length > 0;
    return validityPassword;
  };

  return (
    <div className="main_account">
      <div className="divinppt">
        <div className="personal">Personal Info</div>
        <div className="divsinputs" style={{ width: "100%" }}>
          <div className="forwidthLeft">
            <label
              htmlFor="inputEmail4"
              style={{
                marginLeft: "25px",
                fontSize: "12px",
                fontFamily: "Poppins",
                fontWeight: "500",
              }}
            >
              First Name
            </label>
            <input
              type="email"
              className="form-control inputwidth"
              id="inputEmail4"
              placeholder="First Name"
              style={{ fontSize: "11px", fontFamily: "Poppins" }}
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              autoComplete="off"
            />
            {errors?.firstName && (
              <p
                style={{
                  color: "red",
                  fontSize: "11px",
                  margin: "2px 0px 0px 4px",
                }}
              >
                {errors?.firstName}
              </p>
            )}
          </div>

          <div className="forwidthRight">
            <label
              htmlFor="inputPassword"
              className="md:ml-[40px] ml-[25px]"
              style={{
                fontSize: "12px",
                fontFamily: "Poppins",
                // marginLeft: "40px",
                fontWeight: "500",
              }}
              dateOfBirth
            >
              Last Name
            </label>
            <input
              // className="inputwidth12"
              type="text"
              id="inputPassword"
              placeholder="Last Name"
              style={{ fontSize: "11px", fontFamily: "Poppins" }}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              className="form-control inputwidth12 md:ml-[40px] ml-[25px] "
              autoComplete="off"
            />
            {errors?.lastName && (
              <p
                style={{
                  color: "red",
                  fontSize: "11px",
                  margin: "2px 0px 0px 40px",
                }}
              >
                {errors?.lastName}
              </p>
            )}
          </div>
        </div>
        <div className="divsinputs" style={{ width: "100%" }}>
          <div className="forwidthLeft">
            <label
              htmlFor="inputEmail4"
              style={{
                fontSize: "12px",
                fontFamily: "Poppins",
                fontWeight: "500",
                marginLeft: "25px",
              }}
            >
              Email
            </label>
            <input
              type="email"
              className="form-control inputwidth "
              id="inputEmail4"
              placeholder="Email"
              disabled={true}
              style={{ fontSize: "11px", fontFamily: "Poppins" }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="off"
            />
            {errors?.email && (
              <p
                style={{
                  color: "red",
                  fontSize: "11px",
                  margin: "2px 0px 0px 40px",
                }}
              >
                {errors?.email}
              </p>
            )}
          </div>
          <div className="forwidthRight">
            <label
              className="md:ml-[40px] ml-[25px]"
              htmlFor="inputPassword"
              style={{
                fontWeight: "500",
                // marginLeft: "25px",
                fontSize: "12px",
                fontFamily: "Poppins",
                // marginLeft: "40px",
              }}
            >
              Mobile
            </label>
            <input
              className="form-control inputwidth12"
              id="inputPassword"
              placeholder="Mobile"
              style={{ fontSize: "11px", fontFamily: "Poppins" }}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              autoComplete="off"
            />
            {errors?.phoneNumber && (
              <p
                style={{
                  color: "red",
                  fontSize: "11px",
                  margin: "2px 0px 0px 40px",
                }}
              >
                {errors?.phoneNumber}
              </p>
            )}
          </div>
        </div>
        <div className="divsinputs" style={{ width: "100%" }}>
          <div className="forwidthLeft">
            <label
              for="inputState"
              style={{
                fontSize: "12px",
                fontFamily: "Poppins",
                fontWeight: "500",
                marginLeft: "25px",

                paddingRight: "208px",
              }}
            >
              Gender
            </label>
            <select
              id="inputState"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              class="form-control inputwidth "
              style={{ fontSize: "11px", fontFamily: "Poppins" }}
              autoComplete="off"
            >
              <option selected>Gender</option>
              <option>Male</option>
              <option>Female</option>
              <option>other</option>
            </select>
          </div>

          <div className="forwidthRight">
            <label
              htmlFor="inputPassword  inputwidth12"
              className="md:ml-[40px] ml-[25px] md:pt-[0px] pt-[40px}"
              style={{
                fontSize: "12px",
                fontFamily: "Poppins",
                fontWeight: "500",
                width: "100%",
                // marginLeft: "40px",
              }}
            >
              Date of Birth
            </label>
            <input
              style={{
                fontSize: "11px",
                // width: "100%",
              }}
              type="date"
              max={currentDate}
              className="form-control inputwidth12 dob "
              id="inputPassword"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="checksdiv">
          <div className="div1_patient">
            <div className="custom-file">
              <label className="lable-style-profile" htmlFor="customFile">
                Upload profile picture
              </label>
              <input
                type="file"
                className="custom-file-input"
                placeholder="image"
                autoComplete="image"
                name="image"
                accept="images/*"
                id="customFile"
                onChange={onFileChange}
                style={{ display: "none" }}
              />
            </div>
          </div>

          {/* <div className="div2_patient">
            <div className="check_box">
              <label
                className="container factor"
                style={{ fontSize: "14px", color: "black" }}
              >
                Two Way Factor Authentication
                <input type="checkbox" defaultChecked="checked" />
                <span className="checkmark" />
              </label>
            </div>
          </div> */}
        </div>
        <div className="div1_patient">
          <div className="account_patient">
            <img
              style={{ objectFit: "cover" }}
              src={
                imagePreview
                  ? imagePreview
                  : image
                  ? `${imageURL}/${image}`
                  : "/img/man.png"
              }
              className="image"
            />
          </div>

          <div className="update_btn2">
            <button className="up_btn update_profile" onClick={UpdateProfile}>
              Update
            </button>
          </div>
        </div>
      </div>

      <div className="password_divv">
        <div className="password_he">Password</div>
        <div className="password_inputs">
          <div className="form-row divsinputs" style={{ width: "95%" }}>
            <div className="">
              <label
                htmlFor="inputEmail4"
                style={{
                  marginLeft: "25px",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  fontWeight: "500",
                }}
              >
                New Password
              </label>
              <input
                className="form-control inputwidth"
                id="inputPassword4"
                type={"password"}
                placeholder="********"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                onChange={(e) => setPassword(e.target.value)}
                autautoComplete="off"
                // type="password"
              />
              {passwordErrors?.password && (
                <p
                  style={{
                    color: "red",
                    fontSize: "11px",
                    margin: "4px 0px 0px 20px",
                  }}
                >
                  {passwordErrors?.password}
                </p>
              )}
            </div>
            <div className="">
              <label
                htmlFor="inputPassword4"
                className="cnfrmPassMargin"
                style={{
                  marginLeft: "25px",
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  fontWeight: "500",
                }}
              >
                Confirm Password
              </label>
              <input
                // type="password"
                className="form-control inputwidth12"
                id="inputPassword4"
                placeholder="********"
                type="password"
                style={{ fontSize: "11px", fontFamily: "Poppins" }}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="off"
              />
              {passwordErrors?.confirmPassword && (
                <p
                  style={{
                    color: "red",
                    fontSize: "11px",
                    margin: "4px 0px 0px 40px",
                  }}
                >
                  {passwordErrors?.confirmPassword}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="update_btn4">
          <a href="/dashboard/ViewConsutations">
            <button className="up_btn" onClick={UpdatePassword}>
              Update
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Account;
